"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormRichSelectItem", {
    enumerable: true,
    get: function() {
        return FormRichSelectItem;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Button = require("../../../Button/Button");
const _FormRichSelectContext = require("../FormRichSelectContext");
const _Theme = require("../../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormRichSelectItem = (param)=>{
    let { children, paddingX = true, paddingY = true, sticky = false, notSelectable = false, allowOverflow = false, onClick } = param;
    const { spacers, colors, breakpoints } = (0, _Theme.useTheme)();
    const { setOpen } = (0, _react.useContext)(_FormRichSelectContext.FormRichSelectContext);
    return /*#__PURE__*/ _react.default.createElement("div", {
        role: "option",
        className: _style.default.dynamic([
            [
                "56a417355c8090e5",
                [
                    colors.white,
                    paddingY ? spacers.s3 : "",
                    paddingX ? spacers.s3 : "0",
                    colors.border,
                    spacers.s3,
                    sticky ? "sticky" : "relative",
                    sticky ? "0" : "auto",
                    sticky ? "1" : "0",
                    notSelectable ? "none" : "calc(100% - 4.5rem)",
                    allowOverflow ? "visible" : "hidden",
                    allowOverflow ? "initial" : "ellipsis",
                    breakpoints.sm,
                    paddingY ? spacers.s3 : ""
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "56a417355c8090e5",
                [
                    colors.white,
                    paddingY ? spacers.s3 : "",
                    paddingX ? spacers.s3 : "0",
                    colors.border,
                    spacers.s3,
                    sticky ? "sticky" : "relative",
                    sticky ? "0" : "auto",
                    sticky ? "1" : "0",
                    notSelectable ? "none" : "calc(100% - 4.5rem)",
                    allowOverflow ? "visible" : "hidden",
                    allowOverflow ? "initial" : "ellipsis",
                    breakpoints.sm,
                    paddingY ? spacers.s3 : ""
                ]
            ]
        ])
    }, children), notSelectable ? null : /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        size: "sm",
        variant: "secondary",
        type: "button",
        onClick: (e)=>{
            setOpen(false);
            if (onClick != null) {
                onClick(e);
            }
        }
    }, "Select"), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "56a417355c8090e5",
        dynamic: [
            colors.white,
            paddingY ? spacers.s3 : "",
            paddingX ? spacers.s3 : "0",
            colors.border,
            spacers.s3,
            sticky ? "sticky" : "relative",
            sticky ? "0" : "auto",
            sticky ? "1" : "0",
            notSelectable ? "none" : "calc(100% - 4.5rem)",
            allowOverflow ? "visible" : "hidden",
            allowOverflow ? "initial" : "ellipsis",
            breakpoints.sm,
            paddingY ? spacers.s3 : ""
        ]
    }, "div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;background:".concat(colors.white, ";-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;padding:").concat(paddingY ? spacers.s3 : "", " ").concat(paddingX ? spacers.s3 : "0", ";border-bottom:1px solid ").concat(colors.border, ";margin:0 ").concat(spacers.s3, ";position:").concat(sticky ? "sticky" : "relative", ";top:").concat(sticky ? "0" : "auto", ";z-index:").concat(sticky ? "1" : "0", "}div.__jsx-style-dynamic-selector:last-child{border-bottom:none}span.__jsx-style-dynamic-selector{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:100%;max-width:").concat(notSelectable ? "none" : "calc(100% - 4.5rem)", ";overflow:").concat(allowOverflow ? "visible" : "hidden", ";-o-text-overflow:").concat(allowOverflow ? "initial" : "ellipsis", ";text-overflow:").concat(allowOverflow ? "initial" : "ellipsis", "}@media(max-width:").concat(breakpoints.sm, "px){div.__jsx-style-dynamic-selector{padding:").concat(paddingY ? spacers.s3 : "", " 0}}")));
};

//# sourceMappingURL=FormRichSelectItem.js.map